import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar'
import PageTitle from '../../components/pagetitle'
import Services from '../../components/Services'
import Footer from '../../components/footer'
import Scrollbar from '../../components/scrollbar'
import Logo from '../../images/logo.svg'
import { fetchServices } from '../../api/api';
import { useFetch } from '../../hooks/useFetch';
import { useTranslation } from 'react-i18next';


const ServicePage = () => {
    const {
        data: ServicesData,
        isLoading: ServicesIsLoading,
        error: ServicesIsError
    } = useFetch(["Services"], fetchServices);
    const { t } = useTranslation();
    return (
        <Fragment>
            <Navbar Logo={Logo} />
            <PageTitle pageTitle={t('pageTitles.service')} pagesub={t('pageTitles.service')} />
            <Services services={ServicesData?.data?.data} ServicesIsLoading={ServicesIsLoading} ServicesIsError={ServicesIsError} />
            <Footer ftClass={'wpo-site-footer-s2'} />
            <Scrollbar />
        </Fragment>
    )
};
export default ServicePage;
